// API Configuration
// In development, uses localhost. In production, uses your Render API URL.

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const API_ENDPOINTS = {
  optimizeResume: `${API_BASE_URL}/api/optimize-resume`,
  generatePdf: `${API_BASE_URL}/api/generate-pdf`,
  extractTitle: `${API_BASE_URL}/api/extract-title`,
};

export default API_BASE_URL;
